const benefits =  [
    "Estacionamento",
    "Fretado gratuito",
    "Vale-transporte",
    "Convênio Farmácia",
    "Gympass",
    "Assistência médica",
    "Assistência odontológica",
    "Seguro de Vida",
    "Cesta básica",
    "Cesta de natal",
    "Refeitório",
    "Vale Refeição e/ou Alimentação",
    "Convênio com empresas parceiras",
    "Programa de remuneração variável"
]

export {benefits}